import React from 'react';
import { Navigate } from 'react-router-dom';
import DashboardLayout from 'src/layouts/DashboardLayout';
import MainLayout from 'src/layouts/MainLayout';
import CustomerListView from 'src/views/customer/CustomerListView';
import LoginView from 'src/views/auth/LoginView';
import NotFoundView from 'src/views/errors/NotFoundView';
import Wrong from 'src/views/errors/Wrong';
import ProductListView from 'src/views/product/ProductListView';
import RegisterView from 'src/views/auth/RegisterView';
import UploadFile from 'src/views/uploadFile';
import PaymentSection from './views/paymentSection';
import UserListView from 'src/views/customer/UserListView';
import AccountView from 'src/views/account/AccountView';
import ForgetPassword from './views/auth/ForgetPassword';
import ChangePassword from './views/auth/ChangePassword';

const routes = [
  {
    path: 'app',
    element: <DashboardLayout />,
    children: [
      { path: 'account', element: <AccountView /> },
      { path: 'customers', element: <CustomerListView /> },
      { path: 'user', element: <UserListView /> },
      { path: 'uploads', element: <UploadFile /> },
      { path: 'payment', element: <PaymentSection /> },
      { path: 'products', element: <ProductListView /> },
      // { path: 'settings', element: <SettingsView /> },
      { path: '*', element: <Navigate to="/404" /> }
    ]
  },
  {
    path: '/',
    element: <MainLayout />,
    children: [
      { path: 'login', element: <LoginView /> },
      { path: 'register', element: <RegisterView /> },
      { path: 'forget-password', element: <ForgetPassword /> },
      { path: 'change-pass/:key', element: <ChangePassword /> },
      { path: 'wrong', element: <Wrong /> },
      { path: '404', element: <NotFoundView /> },
      // { path: '/', element: <Navigate to="/app/dashboard" /> },
      { path: '/', element: <LoginView /> },
      { path: '*', element: <Navigate to="/404" /> }
    ]
  }
];

// authCheck =path=>{
//   let token = getStorage("token");
//   if(token){
//     switch (path) {
//       case "customers":
//         return <CustomerListView />

//         break;
//       case "uploads":
//         return <UploadFile />

//       default:
//         return <LoginView />
//         break;
//     }
//   }
// }

export default routes;
